export var ProductInclType;
(function (ProductInclType) {
    ProductInclType[ProductInclType["ALL"] = 1] = "ALL";
    ProductInclType[ProductInclType["INCLUDE"] = 2] = "INCLUDE";
    ProductInclType[ProductInclType["EXCLUDE"] = 3] = "EXCLUDE";
})(ProductInclType || (ProductInclType = {}));
//# sourceMappingURL=product-incl-type.js.map